//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {getFieldConfig} from '../source.js';
import dynamicMultField from '../source-common-module/dynamic-mult-field';
import dynamicSingleField from '../source-common-module/dynamic-single-field';
export default {
  name: "source-offer-view",
  components:{
    dynamicMultField,
    dynamicSingleField
  },
  data(){
    return{
      selectModel:'offer',
      sourceId:null,
      sourceDto:{},
      restTimeText:null,
      taxList:[],
      currentRotationDto:{},
      resetTimer:null,
      sourceNormalQuote:{},
      supplierId:null,
      round:null,
      isOfferdLine:0,
      noOfferdLine:0,
      isGiveUpLine:0,
      realShow:'rank',
      inquiryFieldList:[],
      offerFieldList:[],
      validOfferList:[],
      noTaxAmountField:null,
      taxAmountField:null,
      techAttachList:[],
      busAttachList:[]
    }
  },
  methods:{
    changeShowModel(str){
      this.selectModel = str;
    },
    changeSelected(data,str){
      this.$set(data,'selectShow',str);
    },
    backSourceList(){
      this.$router.go(-1);
    },
    changeShow(data){
      if(data.cellShow){
        this.$set(data,'cellShow',false);
        return;
      }
      this.$set(data,'cellShow',true);
    },
    getSourceDto(){
      this.$loadingShow();
      this.$get(`api/source/${this.sourceId}`).then((res) => {
        if(res){
          this.sourceDto = res;
          if(res.bidType === 'REAL'){
            this.selectModel = 'real';
          }
          this.sourceDto.sourceRotationList = this.sourceDto.sourceRotationList.sort((a,b) => a.round - b.round);
          if(this.round){
            this.currentRotationDto = this.sourceDto.sourceRotationList[this.round - 1];
          }else{
            this.currentRotationDto = this.sourceDto.sourceRotationList[this.sourceDto.currentRound - 1];
          }
          if(this.currentRotationDto.tenderType === 'TECHNICAL'){
            this.selectModel = 'techAttach';
          }
          this.getDynamicField();
          this.getOfferInfo();
        }
        this.$loadingHide();
      }).catch(() => {
        this.$loadingHide();
      })
    },
    getDynamicField(){
      if(this.sourceDto.priceTemplete){
        this.offerFieldList = getFieldConfig(this.sourceDto.priceTemplete).offerFieldList;
        this.inquiryFieldList = getFieldConfig(this.sourceDto.priceTemplete).inquiryFieldList;
        this.validOfferList = this.offerFieldList.filter((val) => {
          return (val.dataType !== 'Multiple' && val.inputRequired);
        });
        if(this.offerFieldList.filter(item => item.englishName === 'NTA')[0]){
          this.noTaxAmountField = this.offerFieldList.filter(item => item.englishName === 'NTA')[0];
        }
        if(this.offerFieldList.filter(item => item.englishName === 'TA')[0]){
          this.taxAmountField = this.offerFieldList.filter(item => item.englishName === 'TA')[0];
        }
      }
    },
    viewField(field,dynamicData){
      this.$refs.multMatDynamic.initData(field,dynamicData);
    },
    getOfferInfo(){
      let obj = {
        id:this.sourceId
      };
      if(this.round){
        obj['round'] = this.round;
      }else{
        obj['round'] = this.sourceDto.currentRound;
      }
      if(this.supplierId){
        obj['supId'] = this.supplierId;
      }
      this.$get('api/sourceNormalQuote/round',obj).then((data) => {
        if(data){
          this.sourceNormalQuote = data;
          if(this.sourceNormalQuote.quoteDtList){
            this.sourceNormalQuote.quoteDtList.forEach((item) => {
              if(!item.attachment){
                item.attachment = {};
              }
            });
          }
          if(!this.sourceNormalQuote.attachment){
            this.sourceNormalQuote.attachment = {};
          }
          this.calateLine();
          this.calcalateAllMont();
          if(this.sourceNormalQuote.auctionRankings && this.sourceNormalQuote.auctionRankings.length){
            this.sourceNormalQuote.auctionRankings = this.sourceNormalQuote.auctionRankings.sort((a,b) =>{
              return a.ranking - b.ranking;
            })
          }
          this.distAttachList();
        }
      })
    },
    distAttachList(){
      let techAttachList = [];
      let busAttachList = [];
      this.sourceNormalQuote.attachmentList.forEach((item) => {
        if(item.type === '02' || item.type === '04'){
          busAttachList.push(item);
        }else{
          techAttachList.push(item);
        }
      });
      this.techAttachList = techAttachList;
      this.busAttachList = busAttachList;
    },
    calateLine(){
      let length = this.sourceNormalQuote.quoteDtList.filter(val => !val.deleted).length;
      this.isGiveUpLine = this.sourceNormalQuote.quoteDtList.filter(val=>val.status=='giveUp').length;
      if(this.validOfferList.length){
        this.sourceNormalQuote.quoteDtList.forEach(val=>{
          if(val.status !== 'giveUp'){
            let bol = this.validOfferList.every((offerField) => {
              return (val.dynamicValueJsonObj && val.dynamicValueJsonObj.data && val.dynamicValueJsonObj.data[offerField.tableName] && (val.dynamicValueJsonObj.data[offerField.tableName][offerField.fieldName] || val.dynamicValueJsonObj.data[offerField.tableName][offerField.fieldName] === 0));
            });
            if(bol){
              val.status = 'quoted';
            }else{
              val.status = null;
            }
          }
        })
      }else {
        this.sourceNormalQuote.quoteDtList.forEach(val=>{
          if(val.status !== 'giveUp'){
            let bol = this.offerFieldList.every((offerField) => {
              return ((offerField.dataType !== 'Multiple' && offerField.fieldStatus === 'ACTIVATED') && val.dynamicValueJsonObj && val.dynamicValueJsonObj.data && val.dynamicValueJsonObj.data[offerField.tableName] && (val.dynamicValueJsonObj.data[offerField.tableName][offerField.fieldName] || val.dynamicValueJsonObj.data[offerField.tableName][offerField.fieldName] === 0) || (offerField.dataType === 'Multiple' && !offerField.hidden && val.dynamicValueJsonObj && val.dynamicValueJsonObj.data && val.dynamicValueJsonObj.data[offerField.tableName] && val.dynamicValueJsonObj.data[offerField.tableName].length));
            });
            if(bol){
              val.status = 'quoted';
            }else{
              val.status = null;
            }
          }
        })
      }
      this.isOfferdLine = this.sourceNormalQuote.quoteDtList.filter(val=>val.status=='quoted' && !val.deleted).length;
      this.noOfferdLine = length - this.isGiveUpLine - this.isOfferdLine;
    },
    //计算 报价含税总额 报价未税总额
    calcalateAllMont(){
      if(this.noTaxAmountField){
        this.sourceNormalQuote.untaxedAmount = this.sourceNormalQuote.quoteDtList.reduce((pre,val)=>{
          if(val.status !== 'giveUp' && val.dynamicValueJsonObj && val.dynamicValueJsonObj.data && val.dynamicValueJsonObj.data[this.noTaxAmountField.tableName] && val.dynamicValueJsonObj.data[this.noTaxAmountField.tableName][this.noTaxAmountField.fieldName]){
            return Number(val.dynamicValueJsonObj.data[this.noTaxAmountField.tableName][this.noTaxAmountField.fieldName]) + pre;
          }
          return pre;
        },0);
      }
      if(this.taxAmountField){
        this.sourceNormalQuote.taxedAmount = this.sourceNormalQuote.quoteDtList.reduce((pre,val)=>{
          if(val.status !== 'giveUp' && val.dynamicValueJsonObj && val.dynamicValueJsonObj.data && val.dynamicValueJsonObj.data[this.taxAmountField.tableName] && val.dynamicValueJsonObj.data[this.taxAmountField.tableName][this.taxAmountField.fieldName]){
            return Number(val.dynamicValueJsonObj.data[this.taxAmountField.tableName][this.taxAmountField.fieldName]) + pre;
          }
          return pre;
        },0);
      }
    },
    //  价格明细、阶梯价、年度降价提示前往pc操作
    editDetail(){
      this.$vux.toast.text('暂不支持在手机端操作明细，请前往pc端操作');
    },
    //  实时竞价信息展示
    changeRealShow(str){
      this.realShow = str;
    }
  },
  mounted(){
    this.sourceId = this.$route.params.id;
    this.round = this.$route.params.round;
    if(this.$route.params.supId){
      this.supplierId = this.$route.params.supId;
      this.getSourceDto();
    }else{
      this.$get(`api/supplier/current-sample`).then((res) => {
        this.supplierId = res.id;
        this.getSourceDto();
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/sources/source-sup/source-offer-view.vue